import React, { FC, useContext, useEffect } from 'react'
import Breadcrumbs from 'components/Breadcrumbs/Breadcrumbs'
import Content from '../Content/Content'
import VerticalDetailsContextProvider from 'store/verticalsDetails/Context'
import Details from 'containers/VerticalPage/ecommerce/Details/Details'
import VerticalPageWrapper from 'containers/VerticalPage/common/VerticalPageWrapper/VerticalPageWrapper'
import { CurrentZone } from 'utils/types'
import { useSelector } from 'react-redux'
import { selectCurrentZone } from 'store/global'
import { changeCurrentZoneIndexesFunc } from 'containers/VerticalPage/common/utils'
import { VerticalContext } from 'store/verticals/Context'
import { NetworkGraphButton } from 'components/network-graph/NetworkGraphButton'

const VerticalPage = (props: { changeCurrentZoneIndexes: changeCurrentZoneIndexesFunc }) => {
  const currentZone: CurrentZone = useSelector(selectCurrentZone)
  const { verticalEntity } = useContext(VerticalContext)

  useEffect(() => {
    props.changeCurrentZoneIndexes({
      baseIndices: currentZone?.ecommerceIndices,
      activityIndices: currentZone?.ecommerceActivityIndices,
    })
  }, [currentZone])

  return (
    <VerticalPageWrapper
      gridContainerSx={{
        gridTemplateColumns: '100%',
      }}
      breadcrumbs={
        <Breadcrumbs
          data={[
            { label: 'Home', href: '/' },
            { label: 'Ecommerce', href: '/ecommerce' },
            { label: verticalEntity?.entityDetails?.name || 'N/A' },
          ]}
        />
      }
      headerAction={<NetworkGraphButton />}
    >
      <Content />
      <VerticalDetailsContextProvider>
        <Details />
      </VerticalDetailsContextProvider>
    </VerticalPageWrapper>
  )
}

export default VerticalPage
